/**
 * Status-Übergänge aus Audit-Log → Konversionsraten zwischen Stufen.
 * Nur Einträge mit field === 'status'.
 */
export function buildStatusTransitions(auditLog = []) {
  const counts = {}; // `${from}>${to}` -> n
  for (const e of auditLog) {
    if (!e || e.field !== 'status') continue;
    const from = String(e.oldValue ?? '').trim();
    const to = String(e.newValue ?? '').trim();
    if (!from || !to || from === to) continue;
    const k = `${from}→${to}`;
    counts[k] = (counts[k] || 0) + 1;
  }
  return counts;
}

/** Top-Übergänge mit Rate: wie viel % der „from“-Events gehen nach „to“ (vereinfacht: to / (sum outgoing from)) */
export function funnelConversionRates(auditLog = [], statusList = []) {
  const transitions = buildStatusTransitions(auditLog);
  const outgoing = {};
  for (const [k, n] of Object.entries(transitions)) {
    const [from] = k.split('→');
    outgoing[from] = (outgoing[from] || 0) + n;
  }
  const rows = [];
  for (const [k, n] of Object.entries(transitions)) {
    const [from, to] = k.split('→');
    const denom = outgoing[from] || n;
    const pct = denom ? Math.round((n / denom) * 100) : 0;
    const labelFrom = statusList.find(s => s.id === from || s.value === from)?.label || from;
    const labelTo = statusList.find(s => s.id === to || s.value === to)?.label || to;
    rows.push({ from, to, labelFrom, labelTo, count: n, pctOfFrom: pct });
  }
  return rows.sort((a, b) => b.count - a.count);
}
